var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgMaintenance = function SvgMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7058 20L11.7949 13.9251L14.0621 11.595L19.973 17.6699L17.7058 20ZM2.80702 20L0.539811 17.6699L7.9892 10.0139L6.15385 8.1276L5.39811 8.9043L4.02159 7.4896V9.76422L3.26586 10.5409L0 7.18447L0.755736 6.40777H2.96896L1.61943 5.0208L5.45209 1.08183C5.81197 0.711974 6.19883 0.443828 6.61269 0.277393C7.02654 0.110957 7.44939 0.0277393 7.88124 0.0277393C8.31309 0.0277393 8.73594 0.110957 9.1498 0.277393C9.56365 0.443828 9.95052 0.711974 10.3104 1.08183L7.82726 3.63384L9.17679 5.0208L8.42105 5.7975L10.2564 7.68377L12.6856 5.18724C12.6136 4.98382 12.5551 4.77115 12.5101 4.54924C12.4651 4.32732 12.4426 4.10541 12.4426 3.8835C12.4426 2.79242 12.807 1.8724 13.5358 1.12344C14.2645 0.37448 15.1597 0 16.2213 0C16.4912 0 16.7476 0.0277393 16.9906 0.0832178C17.2335 0.138696 17.4809 0.221914 17.7328 0.332871L15.0607 3.07906L17.004 5.07628L19.6761 2.3301C19.8021 2.589 19.8875 2.84327 19.9325 3.09293C19.9775 3.34258 20 3.6061 20 3.8835C20 4.97457 19.6356 5.89459 18.9069 6.64355C18.1781 7.39251 17.283 7.76699 16.2213 7.76699C16.0054 7.76699 15.7895 7.7485 15.5735 7.71151C15.3576 7.67453 15.1507 7.6098 14.9528 7.51734L2.80702 20Z",
    fill: "url(#paint0_linear_49128_15829)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49128_15829",
    x1: 9.83126e-8,
    y1: 2.46446,
    x2: 20,
    y2: 17.5355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgMaintenance);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/maintenance.278bbb8bee675dd288d3cb60e36601fc.svg";